/* eslint-disable no-debugger */
import { Fragment } from 'react';

import useMyCustomerSatisfactions from './UseMyCustomerSatisfactions';
import CustomerSatisfactionItem from './CustomerSatisfactrionItem';

import Spinner from '@usas/ui-web/components/spinners/Spinner';

import style from './../../LandingPages.module.css';

const MyCustomerSatisfactions = () => {
  const { customerSatisfactions, isLoading } = useMyCustomerSatisfactions();

  if (isLoading === true) {
    return <Spinner />;
  } else if (Array.isArray(customerSatisfactions) !== true || customerSatisfactions.length === 0) {
    return <Fragment />;
  } else {
    return (
      <Fragment>
        <div className={style.SectionBorder}>
          <div className={style.SectionTitle}>My Member Satisfactions</div>
          <div className='row usas-extra-top-margin'>
            {customerSatisfactions.map((satisfactionItem, i) => <CustomerSatisfactionItem customerSatisfactionItem={satisfactionItem} key={i} />)}
          </div>
        </div>
      </Fragment>
    );
  }
};

export default MyCustomerSatisfactions;